import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';

// Register plugins
Alpine.plugin(collapse);
Alpine.plugin(focus);

// Make Alpine available globally
window.Alpine = Alpine;

// Start Alpine after DOM is ready (matches CDN defer behavior)
document.addEventListener('DOMContentLoaded', () => {
  Alpine.start();
});
